function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import * as React from "react";
import * as Api from "../ajax/SessionApi";
import IntlMessage from '../commons/Intl';
import { Action, Authoring } from "../commons/IntlMessages";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language); // オーサリングメニューモーダル

/**
 * モード
 */

export var Mode;

(function (Mode) {
  /**
   * なし
   */
  Mode[Mode["None"] = 0] = "None";
  /**
   * 表示
   */

  Mode[Mode["Show"] = 1] = "Show";
  /**
   * 表示のみ
   */

  Mode[Mode["ReadOnly"] = 2] = "ReadOnly";
})(Mode || (Mode = {}));
/**
 * メニューモード
 */


export var MenuMode;

(function (MenuMode) {
  /**
   * シーケンスを編集
   */
  MenuMode[MenuMode["EditSequence"] = 0] = "EditSequence";
  /**
   * シーケンスを編集
   */

  MenuMode[MenuMode["EditInteraction"] = 1] = "EditInteraction";
  /**
   * トリガーオブジェクトを追加
   */

  MenuMode[MenuMode["AddEmpty"] = 2] = "AddEmpty";
  /**
   * テキストパネルを追加
   */

  MenuMode[MenuMode["AddTextPanel"] = 3] = "AddTextPanel";
  /**
   * メッセージを管理
   */

  MenuMode[MenuMode["ManageMessage"] = 4] = "ManageMessage";
  /**
   * エフェクトを追加
   */

  MenuMode[MenuMode["AddEffect"] = 5] = "AddEffect";
  /**
   * データパネルを追加
   */

  MenuMode[MenuMode["AddDataPanel"] = 6] = "AddDataPanel";
})(MenuMode || (MenuMode = {}));
/**
 * メインコンポーネント
 */


var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    _this.state = {
      Modal: null,
      UseEffectOption: false,
      UseDataIntegrationOption: false
    };
    Api.GetOrganizationOptions(function (options) {
      if (options != null) {
        _this.setState({
          UseEffectOption: options.UseEffectOption,
          UseDataIntegrationOption: options.UseDataIntegrationOption
        });
      }
    });
    return _this;
  }
  /**
   * メニュー選択時処理
   */


  _createClass(MainComponent, [{
    key: "onSelectMenu",
    value: function onSelectMenu(mode) {
      this.props.onSelectMenu(mode);
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var modal = $('#SessionAuthoringMenuDialogModal');
      this.setState({
        Modal: modal
      });
      modal.modal({
        backdrop: 'static',
        keyboard: false
      }); // ポップアップが完全に非表示になった時のイベント。

      modal.on("hidden.bs.modal", function (e) {
        _this2.props.onHidden();
      });
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "SessionAuthoringMenuDialogModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "38",
        src: "/assets/img/Icon_Authoring.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Authoring.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body row"
      }, /*#__PURE__*/React.createElement("div", {
        className: "col-5 mx-auto"
      }, /*#__PURE__*/React.createElement("a", {
        className: "btn-editsequence",
        href: "#",
        onClick: this.onSelectMenu.bind(this, MenuMode.EditSequence),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Action.EditSequence))), /*#__PURE__*/React.createElement("div", {
        className: "col-7 mx-auto"
      }, /*#__PURE__*/React.createElement("div", {
        className: "btn-horizontal"
      }, /*#__PURE__*/React.createElement("a", {
        className: "btn-editinteraction",
        href: "#",
        onClick: this.onSelectMenu.bind(this, MenuMode.EditInteraction),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Action.EditInteraction)), this.props.mode == Mode.Show && /*#__PURE__*/React.createElement("a", {
        className: "btn-addempty" + (this.state.UseEffectOption ? " btn-margin" : ""),
        href: "#",
        onClick: this.onSelectMenu.bind(this, MenuMode.AddEmpty),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Action.AddEmpty)), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("a", {
        className: "btn-addempty disabled" + (this.state.UseEffectOption ? " btn-margin" : ""),
        tabIndex: -1,
        title: ""
      }, intl.format(Action.AddEmpty)), this.props.mode == Mode.Show && this.state.UseEffectOption && /*#__PURE__*/React.createElement("a", {
        className: "btn-addeffect",
        href: "#",
        onClick: this.onSelectMenu.bind(this, MenuMode.AddEffect),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Action.AddEffect)), this.props.mode == Mode.ReadOnly && this.state.UseEffectOption && /*#__PURE__*/React.createElement("a", {
        className: "btn-addeffect disabled",
        tabIndex: -1,
        title: ""
      }, intl.format(Action.AddEffect))), /*#__PURE__*/React.createElement("div", {
        className: "btn-horizontal"
      }, this.props.mode == Mode.Show && /*#__PURE__*/React.createElement("a", {
        className: "btn-addtextpanel",
        href: "#",
        onClick: this.onSelectMenu.bind(this, MenuMode.AddTextPanel),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Action.AddTextPanel)), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("a", {
        className: "btn-addtextpanel disabled",
        tabIndex: -1,
        title: ""
      }, intl.format(Action.AddTextPanel)), this.props.mode == Mode.Show && /*#__PURE__*/React.createElement("a", {
        className: "btn-managemessage" + (this.state.UseDataIntegrationOption ? " btn-margin" : ""),
        href: "#",
        onClick: this.onSelectMenu.bind(this, MenuMode.ManageMessage),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Action.ManageMessage)), this.props.mode == Mode.ReadOnly && /*#__PURE__*/React.createElement("a", {
        className: "btn-managemessage disabled" + (this.state.UseDataIntegrationOption ? " btn-margin" : ""),
        tabIndex: -1,
        title: ""
      }, intl.format(Action.ManageMessage)), this.props.mode == Mode.Show && this.state.UseDataIntegrationOption && /*#__PURE__*/React.createElement("a", {
        className: "btn-adddatapanel",
        href: "#",
        onClick: this.onSelectMenu.bind(this, MenuMode.AddDataPanel),
        "data-dismiss": "modal",
        title: ""
      }, intl.format(Action.AddDataPanel)), this.props.mode == Mode.ReadOnly && this.state.UseDataIntegrationOption && /*#__PURE__*/React.createElement("a", {
        className: "btn-adddatapanel disabled",
        tabIndex: -1,
        title: ""
      }, intl.format(Action.AddDataPanel)))), /*#__PURE__*/React.createElement("div", {
        className: "col-1"
      }, /*#__PURE__*/React.createElement("div", null))), /*#__PURE__*/React.createElement("div", {
        className: "modal-footer justify-content-center"
      }))));
    }
  }]);

  return MainComponent;
}(React.Component);

export { MainComponent as default };